import axios from 'axios';
import { configs } from '../app/app-configs';
import { WorkoutPlan, WorkoutPlanRequest } from './model/workout.model';

export const getWorkoutPlans = async (memberId: number): Promise<WorkoutPlan[]> => {
    return await axios.get(`${configs.BASE_URL}/workout-plans/member/${memberId}`).then((res) => {
        return res.data;
    });
};


export const getActivePlan = async (memberId: number): Promise<WorkoutPlan> => {
    return await axios.get(`${configs.BASE_URL}/workout-plans/member/${memberId}/active`).then((res) => {
        return res.data;
    });
};

export const getPlan = async (planId: number): Promise<WorkoutPlan> => {
    return await axios.get(`${configs.BASE_URL}/workout-plans/${planId}`).then((res) => {
        return res.data;
    });
};

export const createWorkoutPlan = async (
    request: WorkoutPlanRequest
): Promise<WorkoutPlan> => {
    return await axios
        .post(`${configs.BASE_URL}/workout-plans/member/${request.memberId}`, request)
        .then((res) => {
            return res.data as WorkoutPlan;
        });
};

export const updateWorkoutPlan = async (
    request: WorkoutPlanRequest
): Promise<WorkoutPlan> => {
    return await axios
        .put(`${configs.BASE_URL}/workout-plans/${request.id}`, request)
        .then((res) => {
            return res.data as WorkoutPlan;
        });
};

export const deleteWorkoutPlan = async (id: number): Promise<number> => {
    return await axios
        .delete(`${configs.BASE_URL}/workout-plans/${id}`)
        .then((res) => {
            return res.data;
        });
};
